import { useState } from 'react'
import { useTranslation } from '@/i18n'
import { IntuiButton } from '@/components/intueri/IntuiButton'
import type { Period, RunState } from '../v4/contracts'
import { planPeriod } from './runRules'

/**
 * The approved plan on a new period, as a new run (F11): two dates, prefilled from the period the
 * plan read, and the engine's rerun. Shown on the Report tab and, folded, on the result card.
 */
export default function RerunBar({ run, busy, onRerun }: { run: RunState; busy: boolean; onRerun: (period: Period) => Promise<unknown> }) {
  const { t } = useTranslation()
  const saved = planPeriod(run)
  const [from, setFrom] = useState(saved?.from.slice(0, 10) ?? '')
  const [to, setTo] = useState(saved?.to.slice(0, 10) ?? '')
  const ready = Boolean(from && to && from < to)
  return (
    <form
      className="flex flex-wrap items-end gap-3 rounded-xl border border-border bg-background p-3.5 dark:bg-dark-card"
      onSubmit={(e) => {
        e.preventDefault()
        if (ready) void onRerun({ from: `${from}T00:00:00Z`, to: `${to}T00:00:00Z` })
      }}
    >
      <label className="flex flex-col gap-1 text-xs text-muted-foreground">
        {t('workflow:report.rerun_from', { defaultValue: 'From' })}
        <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="rounded-lg border border-border bg-transparent px-2 py-1 text-sm text-foreground" />
      </label>
      <label className="flex flex-col gap-1 text-xs text-muted-foreground">
        {t('workflow:report.rerun_to', { defaultValue: 'To' })}
        <input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="rounded-lg border border-border bg-transparent px-2 py-1 text-sm text-foreground" />
      </label>
      <IntuiButton type="submit" size="sm" variant="outline" disabled={!ready || busy}>
        {t('workflow:report.rerun', { defaultValue: 'Run again on this period' })}
      </IntuiButton>
    </form>
  )
}

